import { render } from "./AdmTitle.vue?vue&type=template&id=0ca11b0e&scoped=true"
import script from "./AdmTitle.vue?vue&type=script&lang=js"
export * from "./AdmTitle.vue?vue&type=script&lang=js"

import "./AdmTitle.vue?vue&type=style&index=0&id=0ca11b0e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ca11b0e"]])

export default __exports__